<template>
    <div class='main'>
        <div class='content'>
            <div class='content-header'>
                <h3>店舗管理</h3>
                <button class='right-block button is-info' @click='changeActive'>新規追加</button>
            </div>
            <ul class='list'>
                <li v-for="(lab, key) in labs" :key="key" :value="lab.id" class='list-item' role="button" tabindex="0" @click='detail(lab.id)' @keydown.enter.prevent='detail(lab.id)' @keydown.space.prevent='detail(lab.id)'>
                    <input type='text' :id='`enabled-${lab.id}`' :value='lab.name' disabled>
                    <div class='right-block'>
                        <span class='icon' @click.stop='trash(lab.id)'><i class='fas fa-trash' aria-hidden='true'></i></span>
                    </div>
                </li>
            </ul>
        </div>

        <div class="modal" :class="{ 'is-active': isActive }">
            <div class="modal-background" @click='changeActive'></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">店舗新規追加</p>
                    <button class="delete" aria-label="close" @click='changeActive'></button>
                </header>
                <section class="modal-card-body">
                    <div class="field">
                        <label class="label">店舗名</label>
                        <div class="control">
                            <input class="input" type="text" v-model='name' placeholder="店舗名">
                        </div>
                    </div>
                    <div class="field">
                        <label class="label">メールアドレス</label>
                        <div class="control">
                            <input class="input" type="text" v-model='email' placeholder="256文字以下" maxlength='256' required>
                        </div>
                    </div>
                    <div class="field">
                        <label class="label">パスワード</label>
                        <div class="control">
                            <input class="input" type="text" v-model='password' placeholder="256文字以下" maxlength='256' required>
                        </div>
                    </div>
                    <div class="field">
                        <div class="control">
                            <button class="button is-link" @click="autoGenerate('password')">自動生成</button>
                        </div>
                    </div>
                </section>
                <footer class="modal-card-foot">
                    <div class='right-block'>
                        <button class="button is-info" @click='add'>送信</button>
                        <button class="button" @click='changeActive'>閉じる</button>
                    </div>
                </footer>
            </div>
            <button class="modal-close is-large" aria-label="close" @click='changeActive'></button>
        </div>
    </div>
</template>

<script>

export default {
    name: 'School',
    components: {
    },
    data () {
        return {
            isActive: false,
            email: '',
            name: '',
            password: '',
            labs: []
        }
    },
    mounted () {
        const self = this
        this.axios.get(`${process.env.API_URL}/admin/lab`).then((res) => {
            self.labs = res.data.labs
        }).catch((e) => {
            alert('サーバーエラーが発生しました')
        })
    },
    methods: {
        changeActive () {
            this.isActive = !this.isActive

            if (this.isActive) {
                this.autoGenerate('loginId')
                this.autoGenerate('password')
            }
        },
        trash (key) {
            if (window.confirm('削除した店舗に関連する全てのデータは削除されますがよろしいですか？')) {
                this.axios.delete(`${process.env.API_URL}/admin/lab/${key}`).then((res) => {
                    location.reload()
                }).catch((e) => {
                    alert('サーバーエラーが発生しました')
                })
            }
        },
        add () {
            this.axios.post(`${process.env.API_URL}/admin/lab`, {
                name: this.name,
                email: this.email,
                password: this.password
            }).then((res) => {
                if (res.data.message === 'Duplicate') {
                    alert('このメールアドレスは既に利用されています')
                } else {
                    location.reload()
                }
            }).catch((e) => {
                alert('サーバーエラーが発生しました')
            })
        },
        detail (key, e) {
            this.$router.push(`/lab?id=${key}`)
        },
        autoGenerate (model) {
            this[model] = Math.random().toString(32).substring(2)
        }
    }
}
</script>

<style scoped>

.tabs {
    width: calc(100vw - 200px);
}
.content {
    margin: auto;
    padding: 25px;
    width: 780px;
}

.list {
}

.list-item {
    height: 48px;
    padding: 4px 12px;
    list-style: none;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.list-item:hover {
    background: rgba(31, 122, 224, 0.08);
}

.list-item:hover input:disabled {
    background: transparent;
    color: #222;
    cursor: pointer;
}

.list-item input {
    height: 40px;
    font-size: 18px;
    line-height: 40px;
    padding: 0 8px;
}

.list-item input:disabled {
    background: white;
    border: none;
    height: 40px;
    font-size: 18px;
    pointer-events: none;
}

.right-block {
    margin-left: auto;
    display: flex;
    align-items: center;
}

.icon {
    cursor: pointer;
    font-size: 22px;
    padding: 8px 10px;
}

.icon + .icon {
    margin-left: 10px;
}

.content-header {
    display: flex;
    padding-bottom: 20px;
}

.content-header h3 {
    line-height: 40px;
    margin: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/admin/pages/Lab.vue